import * as React from 'react';

const SvgFireMini = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M26.066 14.674a10.858 10.858 0 0 0-2.591-3.6l-.91-.835a.253.253 0 0 0-.406.103l-.406 1.166c-.253.731-.719 1.478-1.378 2.212a.195.195 0 0 1-.128.063.172.172 0 0 1-.134-.047.184.184 0 0 1-.063-.15c.116-1.881-.447-4.003-1.678-6.313-1.019-1.918-2.434-3.415-4.203-4.459l-1.29-.76a.25.25 0 0 0-.376.229l.069 1.5c.047 1.025-.072 1.931-.353 2.684a8.912 8.912 0 0 1-1.469 2.547 9.234 9.234 0 0 1-1.484 1.44 11.019 11.019 0 0 0-3.135 3.798 10.867 10.867 0 0 0-.265 9.071 10.98 10.98 0 0 0 5.856 5.8c1.356.57 2.794.857 4.278.857a11.05 11.05 0 0 0 4.278-.853 10.895 10.895 0 0 0 3.497-2.335A10.819 10.819 0 0 0 27 19.077c0-1.525-.313-3.007-.934-4.404Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgFireMini;
